import { Component, Directive, Input, HostBinding } from '@angular/core';
import { LyTheme } from 'alyle-ui/core';
var ToolbarItem = /** @class */ (function () {
    function ToolbarItem() {
    }
    ToolbarItem.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-toolbar-item',
                },] },
    ];
    /** @nocollapse */
    ToolbarItem.ctorParameters = function () { return []; };
    return ToolbarItem;
}());
export { ToolbarItem };
var LyToolbar = /** @class */ (function () {
    function LyToolbar(theme) {
        this.theme = theme;
        /** Set default bg */
        this._bg = 'primary';
        /** set default color */
        this._color = 'main';
    }
    Object.defineProperty(LyToolbar.prototype, "toolbarBg", {
        set: function (val) {
            this._bg = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyToolbar.prototype, "toolbarColor", {
        set: function (val) {
            this._color = val;
        },
        enumerable: true,
        configurable: true
    });
    LyToolbar.prototype.ngOnInit = function () {
        var _this = this;
        this._subscription = this.theme.palette.subscribe(function (colors) {
            _this.styleBackground = _this.theme.colorOf(_this._bg);
            _this.styleColor = _this.theme.colorOf(_this._color);
        });
    };
    LyToolbar.prototype.ngOnDestroy = function () {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    };
    LyToolbar.decorators = [
        { type: Component, args: [{
                    selector: 'ly-toolbar',
                    template: '<ng-content></ng-content>',
                    styles: [":host[ly-dense] { height: 48px; line-height: 48px; } :host { background: 0 0; margin: 0; max-width: 100%; width: 100%; min-height: 48px; height: 64px; box-sizing: border-box; display: flex; align-items: center; position: relative; font-size: 20px; } ",
                        ":host /deep/ ly-toolbar-item { font-weight: 400; vertical-align: middle; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } :host /deep/ ly-toolbar-item[ly-toolbar-item-padding] { padding: 0 16px; } "],
                },] },
    ];
    /** @nocollapse */
    LyToolbar.ctorParameters = function () { return [
        { type: LyTheme, },
    ]; };
    LyToolbar.propDecorators = {
        "styleBackground": [{ type: HostBinding, args: ['style.background',] },],
        "styleColor": [{ type: HostBinding, args: ['style.color',] },],
        "toolbarBg": [{ type: Input },],
        "toolbarColor": [{ type: Input },],
    };
    return LyToolbar;
}());
export { LyToolbar };
//# sourceMappingURL=toolbar.js.map